import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 's18-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  show: boolean = true;
  version: string = environment.VERSION;

  constructor(
    private localStorage: LocalStorageService,
    private router: Router
  ) {

  }

  ngOnInit() {
    this.show = !this.localStorage.get('hideFooter');
  }

  toggleHeaderFooter() {
    if (this.show) {
      this.localStorage.set('hideHeader', true);
      this.localStorage.set('hideFooter', true);
      return;
    }
    this.localStorage.set('hideHeader', false);
    this.localStorage.set('hideFooter', false);
    this.router.navigateByUrl('');
  }

}
